import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  container: {
    padding: '20px 0',
    position: 'relative',
  },
  button: {
    border: '1px solid #e1e1e1',
    borderRadius: 10,
    width: '100%'
  },
  selectedContainer: {
    borderColor: theme.palette.primary.main
  },
  logo: {
    width: 40,
    marginRight: 10
  },
  checkIcon: {
    width: 20,
    height: 20,
    position: 'absolute',
    right: 4
  },
}))

export default useStyles
